export const roleToRoleDescription = (role) => {                        

    const regionName = role.region ? ` - ${role.region.name}` : '';
    const competitionName = role.competition ? ` - ${role.competition.name}` : '';
    const skillName = role.skill ? ` - ${role.skill.name}` : '';

    switch (role.type) {
        case 'competiteur':
            return `Compétiteur${skillName}${regionName}${competitionName}`;
        case 'jure':
            return `Juré${skillName}${regionName}${competitionName}`;
        case 'jure_supp':
            return `Juré suppléant${skillName}${regionName}${competitionName}`;
        case 'expert_nat':
            return `Expert national${skillName}`;
        case 'expert_nat_adj':
            return `Expert national adjoint${skillName}`;
        case 'expert_int':
            return `Expert international${skillName}`;
        case 'expert_ref_ter':
            return `Expert référent territorial${skillName}`;
        case 'orga_metier_reg':
            return `Organisateur métier régional${skillName}${regionName}`;
        case 'corr_region':
            return `Correspondant régional${regionName}`;
        case 'team_leader': {
            const region_or_france = regionName.length > 0 ? regionName : ' - France';
            return `${role.name}${region_or_france}`;
        }
        default:
            return `${role.name}`;
    }

}